import type { FC } from "react";
import { useIsTablet } from "../../../../../hooks/use-is-screensize";
import Icon from "../../../Icon";
import * as s from "./Review.module.scss";

type ReviewProps = {
	rating: number;
	title: string;
	quote: string;
	name: string;
};

const Review: FC<ReviewProps> = ({ rating, title, quote, name }) => {
	const ratingSlots = Array.from({ length: 5 })
		.fill(0)
		.map((_, i) => (i < rating ? 1 : 0));

	const isTablet = useIsTablet();

	return (
		<div className={s.review}>
			<span>
				{ratingSlots.map((r, i) => (
					<Icon
						key={i}
						icon={r === 1 ? "star-filled" : "star-stroke"}
						width={isTablet ? 20 : 14}
						color="var(--color-brown-2)"
					/>
				))}
			</span>
			{title && <p className={s.title}>{title}</p>}
			{quote && <blockquote>{quote}</blockquote>}
			<p className={s.name}>{name}</p>
		</div>
	);
};

export default Review;
